import { render, staticRenderFns } from "./verification-code.vue?vue&type=template&id=0f8c351e&scoped=true&"
import script from "./verification-code.vue?vue&type=script&lang=js&"
export * from "./verification-code.vue?vue&type=script&lang=js&"
import style0 from "./verification-code.vue?vue&type=style&index=0&id=0f8c351e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c351e",
  null
  
)

export default component.exports